export default __webpack_public_path__ + "static/media/No-Image.5f67f681.png";